/* eslint-disable @typescript-eslint/no-unused-vars */
import { Paginated } from "@/@types/paginated";
import {
  ICreateSupplier,
  ISupplier,
  ISupplierById,
  ISupplierParams,
  IUpdateSupplier,
} from "@/@types/supplier";
import { Tags } from "@/enum/tags";
import { apiSlice } from "./http";

export const supplierService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSuppliers: builder.query<Paginated<ISupplier>, ISupplierParams>({
      query: ({
        meta,
        search,
        supplier_name,
        supplier_number,
        cnpj,
        created_at,
      }) => {
        const paramsObj = {
          search,
          supplier_name,
          supplier_number,
          cnpj,
          created_at,
          page: meta.page?.toString(),
          perPage: meta.perPage?.toString(),
        };

        const params = new URLSearchParams(
          Object.entries(paramsObj)
            .filter(([_, value]) => value !== undefined)
            .reduce(
              (acc, [key, value]) => ({ ...acc, [key]: value as string }),
              {}
            )
        );

        return {
          url: `/supplier/supplier-all?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.SUPPLIER],
    }),
    createSupplier: builder.mutation<void, ICreateSupplier>({
      query: (body) => ({
        url: `/supplier/supplier-create`,
        method: "POST",
        body,
      }),
    }),
    toggleSupplier: builder.mutation<void, number>({
      query: (id) => ({
        url: `/supplier/supplier-toggle?id=${id}`,
        method: "PATCH",
      }),
      invalidatesTags: [Tags.SUPPLIER],
    }),
    updateSupplier: builder.mutation<
      void,
      { id: number; body: IUpdateSupplier }
    >({
      query: ({ id, body }) => ({
        url: `/supplier/supplier-update?id=${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: [Tags.SUPPLIER],
    }),
    getSupplierById: builder.query<ISupplierById, number>({
      query: (id) => ({
        url: `/supplier/supplier-id?id=${id}`,
        method: "GET",
      }),
      providesTags: [Tags.SUPPLIER],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetSuppliersQuery,
  useCreateSupplierMutation,
  useToggleSupplierMutation,
  useGetSupplierByIdQuery,
  useUpdateSupplierMutation,
} = supplierService;

export const {
  endpoints: {
    getSuppliers: { select: selectSuppliers },
    createSupplier: { select: createSupplier },
    toggleSupplier: { select: toggleSupplier },
    getSupplierById: { select: getSupplierById },
    updateSupplier: { select: updateSupplier },
  },
} = supplierService;
